import styled, { keyframes } from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

const slideIn = keyframes`
  from { transform: translate(0, 0); }
  to { transform: translate(0, calc(-100% - 12px)); }
`;

const slideOut = keyframes`
  from { transform: translate(0, calc(-100% - 12px)); }
  to { transform: translate(0, 0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const Container = styled.div`
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
  gap: 10px;
  width: 310px;
  background-color: ${colors.purple1};
  color: ${colors.whiteText};
  border-radius: 8px;
  opacity: 0;
  filter: drop-shadow(0px 20px 35px rgba(0, 0, 0, 0.09));

  &::after {
    content: '';
    position: absolute;
    inset: 100% 28px auto auto;
    border: 4px solid transparent;
    border-top-color: ${colors.purple1};
  }
`;

export const Root = styled.div`
  font-family: Roboto, sans-serif;
  position: absolute;
  right: 16px;
  transform: translate(0, 0);

  animation-name: ${(props) => (props.show ? slideIn : slideOut)};
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation-delay: ${(props) => (props.show ? '0s' : '400ms')};
  animation-fill-mode: ${(props) => (props.show ? 'forwards' : 'backwards')};

  & ${Container} {
    animation-name: ${(props) => (props.show ? fadeIn : fadeOut)};
    animation-duration: ${(props) => (props.show ? '300ms' : '200ms')};
    animation-timing-function: linear;
    animation-delay: ${(props) => (props.show ? '600ms' : '0s')};
    animation-fill-mode: ${(props) => (props.show ? 'forwards' : 'backwards')};
  }

  & > img {
    margin-right: 12px;
  }
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  line-height: 155%;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: ${colors.whiteText};
  margin: 0;

  & > svg {
    color: ${colors.purple5};
  }
`;

export const Description = styled.p`
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.purple5};
  margin: 0;
`;

export const BotDialogPillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BotDialogPill = styled.label`
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  background-color: ${colors.purple8};
  color: ${colors.whiteText};
  border-radius: 48px;
  padding: 2px 8px;
  margin: 0;
  cursor: pointer;
`;

export const BotDialogButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
`;

export const BotDialogButton = styled.button`
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  border: 1px solid;
  height: 24px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 3px;
`;

export const BotDialogButtonOutline = styled(BotDialogButton)`
  color: ${colors.whiteText};
  border-color: ${colors.whiteText};
  background-color: rgba(0 0 0 / 0);
`;

export const BotDialogButtonWhite = styled(BotDialogButton)`
  color: ${colors.purple1};
  background-color: ${colors.whiteText};
  border-color: ${colors.whiteText};

  &[disabled] {
    background-color: ${colors.purple9};
    border-color: ${colors.purple9};
  }
`;
